import { MARKETPLACE_FEATURE } from '@/config/marketplaceCapabilities.js';

// Amazon seller order flow — orders, MCF orders, shipments, returns and FBA returns. Split out of Inventory; the
// pages still live under /inventory/*, so the feature gate stays the Inventory one.
// No group-level envOnly: Orders, MCF Orders and FBA Returns are released, and VerticalNavGroup
// gates the group itself — a dev-only group would hide its released children. Shipments and
// Returns stay individually dev-only.
export default [
  {
    title: 'Orders',
    channel: 'amazon-seller',
    icon: { icon: 'ic:outline-receipt-long' },
    feature: MARKETPLACE_FEATURE.INVENTORY,
    children: [
      {
        title: 'Orders',
        action: 'read',
        subject: 'User',
        to: 'inventory-orders',
        icon: { icon: 'ic:outline-shopping-cart' },
      },
      {
        title: 'MCF Orders',
        action: 'read',
        subject: 'User',
        to: 'inventory-mcf-orders',
        icon: { icon: 'ic:outline-outbox' },
      },
      {
        title: 'Customer Shipments',
        action: 'read',
        subject: 'User',
        to: 'inventory-shipments',
        icon: { icon: 'ic:outline-local-shipping' },
        envOnly: 'development',
      },
      {
        title: 'Returns',
        action: 'read',
        subject: 'User',
        to: 'inventory-returns',
        icon: { icon: 'ic:outline-keyboard-return' },
        envOnly: 'development',
      },
      {
        title: 'FBA Returns',
        action: 'read',
        subject: 'User',
        to: 'inventory-fba-returns',
        icon: { icon: 'ic:outline-assignment-return' },
      },
    ],
  },
];
